import { useState } from "react";

const statusConfig = {
  "": { label: "", className: "btn-outline-light", title: "Not marked" },
  "PRESENT": { label: "P", className: "btn-success", title: "Present" },
  "ABSENT": { label: "A", className: "btn-danger", title: "Absent" },
  "HALF_DAY": { label: "H", className: "btn-warning", title: "Half Day" },
};

const statusOrder = ["PRESENT", "ABSENT","HALF_DAY"];

export function AttendanceStatusCell({
  employeeId,
  date,
  status,
  onStatusChange,
  isPastDate = false,
  isFutureDay = false,
  isEditable=false
}) {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    if (isPastDate&&!isEditable) return;
    if (isFutureDay) return;
    const currentIndex = statusOrder.indexOf(status);
    const nextIndex = (currentIndex + 1) % statusOrder.length;
    const nextStatus = statusOrder[nextIndex];
    onStatusChange(employeeId, date, nextStatus,true);
  };

  const config = statusConfig[status] || statusConfig[""];
  
  return (
    <div className="position-relative">
      <button
        className={`btn btn-sm ${config.className}`}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          width: '30px',
          height: '30px',
          fontSize: '12px',
          fontWeight: 'bold',
          cursor: isPastDate&&(!isEditable) ? 'not-allowed' : 'pointer',
          opacity:isPastDate&&!isEditable?0.55: 1,
        }}
      >
        {config.label}
      </button>
      
      {isHovered && status&& (
        <div
          className="position-absolute bg-dark text-white px-2 py-1 rounded shadow-sm"
          style={{
            top: '-35px',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '11px',
            zIndex: 1000,
            whiteSpace: 'nowrap',
          }}
        >
          {config.title}
        </div>
      )}
    </div>
  );
}